import React from 'react';
import Redirect from '../assets/images/Vector.svg';

export default () => {
  return <img src={Redirect} alt="" />;
};
